import { render } from "./MusubiPartSwitcher.vue?vue&type=template&id=095aba78&scoped=true"
import script from "./MusubiPartSwitcher.vue?vue&type=script&lang=js"
export * from "./MusubiPartSwitcher.vue?vue&type=script&lang=js"

import "./MusubiPartSwitcher.vue?vue&type=style&index=0&id=095aba78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-095aba78"]])

export default __exports__